/**
 * Franjas solicitadas:
 * - 12–14 h: horas 12 y 13
 * - 14–16 h: horas 14 y 15
 * - 16–12 h: resto (16–23 y 0–11), es decir de 16:00 a 11:59 en el ciclo diario.
 */
export type HourRangeSlot = 'range_12_14' | 'range_14_16' | 'range_16_12';

export function hourToRangeSlot(hour: number): HourRangeSlot {
  if (hour >= 12 && hour < 14) return 'range_12_14';
  if (hour >= 14 && hour < 16) return 'range_14_16';
  return 'range_16_12';
}
